'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var qrcanvas = require('qrcanvas');

var index = {
  props: ['options'],
  render: function render(h) {
    return h('canvas');
  },
  methods: {
    update: function update(options) {
      // Render only if mounted, skip SSR.
      if (!this.mounted) return;
      this.$emit('beforeUpdate', this.$el);
      qrcanvas.qrcanvas(_objectSpread({}, options, {
        canvas: this.$el
      }));
      this.$emit('updated', this.$el);
    }
  },
  watch: {
    options: 'update'
  },
  mounted: function mounted() {
    this.mounted = true;
    this.update(this.options);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/qrcanvas-vue/lib/qrcanvas-vue.common.js
// module id = h4In
// module chunks = 0